/* @flow strict */

export function descructureRelayId_DONOTUSE(relayId: string): [string, string] {
  const transparentId = atob(relayId);
  const [type, id] = transparentId.split(":");
  // The variables [type, id] may seem redundant but the destructuring
  // gives us two parts in case there's more
  return [type, id];
}
